<template>
<div class="ag-courses_item">
    <div class="ag-courses-item_link">
        <div :class="getRowClass"></div>

        <div class="ag-courses-item_title">
            {{ getStudentName }}
        </div>

        <div class="ag-courses-item_title">
            {{ getStatus }}
        </div>

        <div class="ag-courses-item_date-box">
            Created:
            <span class="ag-courses-item_date">
                {{ createdAt }}
            </span>
        </div>

        <div class="ag-courses-item_date-box">
            Updated:
            <span class="ag-courses-item_date">
                {{ lastUpdate }}
            </span>
        </div>

        
    </div>
</div>
</template>

<script>
import {
    statusOptionsClasses
} from '../../models/static'
import moment from 'moment';

export default {
    name: "bubble",
    props: ['application'],
    data() {
        return {}
    },
    mounted() {},
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        getRowClass() {
            const rowClass = !this.application.status || !statusOptionsClasses[this.application.status] ? 'status-nude' : statusOptionsClasses[this.application.status]

            return `ag-courses-item_bg ${rowClass}`
        },
        lastUpdate() {
            return this.application.student ? moment(this.application.student.updatedAt).format('LLL') : 'Invalid Date'
        },
        createdAt() {
            return this.application.student ? moment(this.application.student.createdAt).format('LLL') : 'Invalid Date'
        },
        getStatus() {
            return this.application.status ? this.application.status : 'No status yet'
        },
        getStudentName() {
            if(this.application.student && this.application.student.templateOptions) {
                const studentData = this.application.student.templateOptions
            return this.studentName(studentData.personalInformation)
            } else {
                return 'Invalid student'
            }
            
        }

    },
    methods: {
        studentName(student) {
            return student.title + " " + student.first_name + " " + student.last_name;
        },
    }
}
</script>

<style>
.ag-courses_item {
    /* -ms-flex-preferred-size: calc(33.33333% - 30px);
  flex-basis: calc(33.33333% - 30px); */

    margin: 0 15px 30px;

    overflow: hidden;

    border-radius: 28px;
}

.ag-courses-item_link {
    display: block;
    padding: 30px 20px;
    background-color: #121212;

    overflow: hidden;

    position: relative;
}

.ag-courses-item_title {
    margin: 0 0 25px;

    font-weight: bold;
    font-size: 30px;
    color: #FFF;

    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box;
    /* max-width: 200px; */
}

.ag-courses-item_date-box {
    font-size: 18px;
    color: #FFF;

    z-index: 2;
    position: relative;
}

.ag-courses-item_date {
    font-weight: bold;
    color: #f9b234;
}

.ag-courses-item_bg {
    height: 128px;
    width: 128px;
    background-color: #f9b234;

    z-index: 1;
    position: absolute;
    top: -75px;
    right: -75px;

    border-radius: 50%;
}

</style>
